import {keys} from 'lodash'
import videojs from 'video.js'
import uaDetect from './ua-detect'

const FOOFOO = window.FOOFOO

export default () => {
  const $videos = $('.video-js')

  const { isSafari } = uaDetect

  if (!$videos.length || !keys(videojs.getPlayers()).length) {
    return
  }

  $(document).off('modal:open').on('modal:open', (event, data = {}) => {
    if (data.media === 'video' && document.getElementById(`ModalVideo--${data.id}`) != null) {
      videojs(`ModalVideo--${data.id}`).play()

      // weird hack for safari
      if (isSafari) {
        setTimeout(() => {
          videojs(`ModalVideo--${data.id}`).play()
        }, 300)
      }

      FOOFOO.screensaverIsDisabled = true
    }
  })

  $(document).off('modal:close').on('modal:close', (event, data = {}) => {
    if (data.media === 'video' && document.getElementById(`ModalVideo--${data.id}`) != null) {
      videojs(`ModalVideo--${data.id}`).currentTime(0).pause()
      FOOFOO.screensaverIsDisabled = false
    }
  })

  $(document).off('screensaver:open').on('screensaver:open', (event) => {
    if (document.getElementById('ScreensaverVideo') != null) {
      videojs('ScreensaverVideo').play()
    }
  })

  $(document).off('screensaver:close').on('screensaver:close', (event) => {
    if (document.getElementById('ScreensaverVideo') != null) {
      videojs('ScreensaverVideo').currentTime(0).pause()
    }
  })
}



// WEBPACK FOOTER //
// ./video-player.js